<template>
    <div class="alert alert-danger alert-icon" role="alert" ref="errorRef">
        <div class="alert-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'DisplayFailed',
  mounted () {
    this.$nextTick(() => {
      this.$refs.errorRef.scrollIntoView({ behavior: 'smooth' })
    })
  }
}
</script>
